import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';

function BrandMark({
  variant = 'hero',
  className = '',
  logoSrc = '/logo.png',
  iconSrc = '/icono.png',
}) {
  const { t } = useLanguage();
  const logoAlt = t.brand?.logoAlt || 'Enrola by Elantar logo';

  if (variant === 'compact') {
    return (
      <div className={`inline-flex items-center justify-center ${className}`}>
        <div className="flex h-16 w-16 shrink-0 items-center justify-center overflow-hidden rounded-3xl shadow-glow">
          <img src={iconSrc} alt={logoAlt} className="h-full w-full object-contain" />
        </div>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className={className}>
        <img src={logoSrc} alt={logoAlt} className="mx-auto h-12 w-auto object-contain lg:mx-0" />
      </div>
    );
  }

  return (
    <motion.div
      initial={{ scale: 0.92, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.8, ease: 'backOut' }}
      className={`inline-flex items-center justify-center ${className}`}
    >
      <img
        src={logoSrc}
        alt={logoAlt}
        className="h-16 w-auto max-w-[12rem] object-contain object-center sm:h-20 sm:max-w-[16rem] lg:h-24 lg:max-w-[18rem]"
      />
    </motion.div>
  );
}

export default BrandMark;
